import Lottie from 'react-lottie';

const Animation = ({ data, width = '', height = '', autoplay = true, isStopped }) => {
    const defaultOptions = {
        loop: true,
        autoplay, 
        animationData: data
    };

    return(
        <div>
            <Lottie options={defaultOptions}
                width={width}
                height={height}
                isStopped={isStopped}
            />
        </div>
    )
}

export default Animation